import { saveAs } from "file-saver";
import { Logger } from "./";

interface IDownloadConfig {
  fileType: string;
  responseType: XMLHttpRequestResponseType;
  requestMethod?: string;
}

export const fileDownloader = (
  url: string,
  fileName: string,
  { responseType, fileType, requestMethod = "GET" }: IDownloadConfig
): Promise<any> => {
  return new Promise((resolve, reject) => {
    const request = new XMLHttpRequest();

    request.open(requestMethod, url, true);
    request.responseType = responseType;

    request.onload = function () {
      const file = new Blob([request.response], {
        type: fileType,
      });
      saveAs(file, fileName);
      resolve(file);
    };

    request.onerror = function () {
      const errorText = this.status + " " + request.statusText;
      const error = new Error(errorText);

      Logger.error(error);
      reject();
    };

    request.send();
  });
};

export const pdfDownloader = (url: string, fileName: string) => {
  return fileDownloader(url, fileName, {
    responseType: "blob",
    fileType: "application/pdf",
  });
};
